const BASE_URL = process.env.REACT_APP_BASE_URL

export const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

// type APIResponseModule = {
//     moduleId: string;
//     moduleName: string;
//     description: string;
//     currentPage: number;
//     nextPage: number;
//     totalPages: number;
//     tutorialId: string;
//     tutorialName: string;
//     htmlContent: string;
//     category: string;
//     type: TutorialType;
// }

// export const APIFetchModule = async (moduleId: string): Promise<{status: boolean, data: APIResponseModule | null, message: string}> => {
//     const URL: string = `${BASE_URL}/tutorial/api/v1/getFullModuleDetails?moduleId=${moduleId}`
//     const HEAD: RequestInit = {
//         method: 'GET',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${getToken()}`
//         }
//     }

//     try
//     {
//         const response = await fetch(URL, HEAD)

//         if (response.ok)
//         {
//             const responseData = await response.json() as ResponseTypes
//             return {status: true, data: responseData.data as APIResponseModule, message: 'success'}
//         }
//         else
//         {
//             console.error("failed getting tutorial data from the server")
//             return {status: false, data: null, message: 'failed getting tutorial data from the server'}
//         }
//     }
//     catch (error)
//     {
//         console.error("error getting tutorial data from the server with error", error)
//         return {status: false, data: null, message: 'error getting tutorial data from the server'}
//     }
// }

// export type TutorialType = 'video' | 'quiz'

// // Get Page details
// export type APIRequestPageDetails = {
//     moduleId: string;
// }

// type APIResponsePageDetails = {
//     moduleId: string;
//     moduleName: string;
//     description: string;
//     currentPage: number;
//     nextPage: number;
//     totalPages: number;
//     tutorialId: string;
//     tutorialName: string;
//     htmlContent: string;
//     category: string;
//     type: TutorialType;
//     status: boolean;
//     validUntil: string | null;
// }

// export const APIGetPageDetails = async (body: APIRequestPageDetails): Promise<{status: boolean, data: APIResponsePageDetails | null, message: string}> => {
//     const URL: string = `${BASE_URL}/tutorial/api/v1/getFullModuleDetails`
//     const HEAD: RequestInit = {
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${getToken()}`
//         },
//         body: JSON.stringify(body)
//     }

//     try
//     {
//         const response = await fetch(URL, HEAD)

//         if (response.ok)
//         {
//             const responseData = await response.json() as ResponseTypes
//             return {status: true, data: responseData.data as APIResponsePageDetails, message: 'success'}
//         }
//         else
//         {
//             console.error("failed getting tutorial data from the server")
//             return {status: false, data: null, message: 'failed getting tutorial data from the server'}
//         }
//     }
//     catch (error)
//     {
//         console.error("error getting tutorial data from the server with error", error)
//         return {status: false, data: null, message: 'error getting tutorial data from the server'}
//     }
// }

// // Got to next

// // Next Page details
// export type APIRequestGoToNext = {
//     moduleId: string;
// }

// export const APIGotToNext = async (body: APIRequestGoToNext): Promise<{status: boolean, message: string}> => {
//     const URL: string = `${BASE_URL}/tutorial/api/v1/goToNext`
//     const HEAD: RequestInit = {
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${getToken()}`
//         },
//         body: JSON.stringify(body)
//     }

//     try
//     {
//         const response = await fetch(URL, HEAD)

//         if (response.ok)
//         {
//             return {status: true, message: 'success'}
//         }
//         else
//         {
//             console.error("failed getting tutorial data from the server")
//             return {status: false, message: 'failed getting tutorial data from the server'}
//         }
//     }
//     catch (error)
//     {
//         console.error("error getting tutorial data from the server with error", error)
//         return {status: false, message: 'error getting tutorial data from the server'}
//     }
// }


// // Get quiz answer
// export type APIResponseQuizAnswer = {
//     question: string;
//     answer: string;
// }

// export type APIRequestQuizAnswer = {
//     moduleId: string;
//     tutorialId: string;
// }

// export const APIGetQuizAnswers = async (body: APIRequestQuizAnswer): Promise<{status: boolean, data: APIResponseQuizAnswer[], message: string}> => {
//     const URL: string = `${BASE_URL}/tutorial/api/v2/getQuizAnswers`
//     const HEAD: RequestInit = {
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${getToken()}`
//         },
//         body: JSON.stringify(body)
//     }

//     try
//     {
//         const response = await fetch(URL, HEAD)

//         if (response.ok)
//         {
//             return {status: true, data: [], message: 'success'}
//         }
//         else
//         {
//             console.error("failed getting tutorial data from the server")
//             return {status: false, data: [], message: 'failed getting tutorial data from the server'}
//         }
//     }
//     catch (error)
//     {
//         console.error("error getting tutorial data from the server with error", error)
//         return {status: false, data: [], message: 'error getting tutorial data from the server'}
//     }
// }

export type APIRequestDetails = {
    moduleId: string;
}

export type APIResponseTutorialDetails = {
    tutorialId: string;
    tutorialName: string;
    html: string;
    status: boolean;
    step: number;
    type: string;
    isRequired: boolean;
}

export type APIResponseDetails = {
    moduleId: string;
    moduleName: string;
    tutorials: APIResponseTutorialDetails[];
}

export const APIGetDetails = async (body: APIRequestDetails): Promise<{status: boolean, data: APIResponseDetails | null, message: string}> => {
    const URL: string = `${BASE_URL}/tutorial/api/v2/getDetails`
    const HEAD: RequestInit = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEAD)

        if (response.ok)
        {
            const responseData = await response.json() as ResponseTypes
            return {status: true, data: responseData.data, message: 'success'}
        }
        else
        {
            console.error("failed getting tutorial data from the server")
            return {status: false, data: null, message: 'failed getting tutorial data from the server'}
        }
    }
    catch (error)
    {
        console.error("error getting tutorial data from the server with error", error)
        return {status: false, data: null, message: 'error getting tutorial data from the server'}
    }
}

export type APIRequestClickNext = {
    tutorialId: string;
}

export const APIGotToNext = async (body: APIRequestClickNext): Promise<{status: boolean, message: string}> => {
    const URL: string = `${BASE_URL}/tutorial/api/v2/toNext`
    const HEAD: RequestInit = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEAD)

        if (response.ok)
        {
            return {status: true, message: 'success'}
        }
        else
        {
            console.error("failed getting tutorial data from the server")
            return {status: false, message: 'failed getting tutorial data from the server'}
        }
    }
    catch (error)
    {
        console.error("error getting tutorial data from the server with error", error)
        return {status: false, message: 'error getting tutorial data from the server'}
    }
}